import { render } from "./mainhead.vue?vue&type=template&id=2e6e4d1e&scoped=true"
import script from "./mainhead.vue?vue&type=script&lang=js"
export * from "./mainhead.vue?vue&type=script&lang=js"

import "./mainhead.vue?vue&type=style&index=0&id=2e6e4d1e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6e4d1e"]])

export default __exports__